export const DEFAULT_RGB_BRIGHTNESS = 0;
export const DEFAULT_RGB_CONTRAST = 0;
export const DEFAULT_RGB_GAMMA = 1;
export const DEFAULT_MAX_POINT_SIZE = 50;
export const DEFAULT_MIN_NODE_PIXEL_SIZE = 50;
export const DEFAULT_MIN_POINT_SIZE = 2;
export const DEFAULT_POINT_BUDGET = 1_000_000;
export const MAX_LOADS_TO_GPU = 2;
export const MAX_NUM_NODES_LOADING = 4;
export const PERSPECTIVE_CAMERA = "PerspectiveCamera";
